import React, { useState } from 'react'
import { Button, Flex } from 'antd'
import StringMask from "string-mask";
import { useToasts } from 'react-toast-notifications';
import HeaderNoregister from '../../componentes/headerNoRegister';
import { useNavigate } from 'react-router-dom';
import ValidarDeclaracaoCtrl from '../../componentes/validarDeclaracaoQuitacaoCtrl';


const DELIMITERS = [".", "-", "/"];
const CPF_MASK = "000.000.000-00";

function removeTrailingCharIfFound(str, chars) {
    let result = str;

    chars.forEach(c => {
        if (str[str.length - 1] === c) {
            result = str.slice(0, str.length - 1);
        }
    });

    return result;
}

function formatValue(str) {
    const unmaskedValue = str.replace(/[.\-\/]/g, "").trim();
    let mask = CPF_MASK;

    const formatted = StringMask.process(unmaskedValue, mask);
    return removeTrailingCharIfFound(formatted.result, DELIMITERS);
}


export const ValidarDeclaracaoQuitacao = (props) => {

    const navigate = useNavigate()

    const [cpf, setCpf] = useState('')
    const [nome, setNome] = useState('')
    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [data, setData] = useState(undefined)

   

    return (
        <Flex vertical>
            <HeaderNoregister />
            <Flex justify='center'>
                <ValidarDeclaracaoCtrl />
            </Flex>

            <Flex justify='center'>
                <Button type='text' onClick={() => {
                    navigate('/')
                }}>Voltar</Button>
            </Flex>
        </Flex>


    )
}


export default ValidarDeclaracaoQuitacao